export default {
  LOAD_COMPETENCY_SURVEY_LIST_START: 'LoadCompetencySurveyListStart',
  LOAD_COMPETENCY_SURVEY_LIST_END: 'LoadCompetencySurveyListEnd',
  TOGGLE_COMPETENCY_SURVEY_LIST_CONFIRM_DIALOG: 'ToggleCompetencySurveyListConfirmDialog'
};